<template>
  <div id="InstallCode" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1" :class="!$route.query.install_code ? 'color-primary' : 'color-white'"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">I</span>nstalar</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt10 pb10 pl20 pr20 color-muted">
      Esta función se utiliza para generar una contraseña de instalación de técnico. Complete el código de instalación que se muestra en la interfaz del programa de instalación en el cuadro de entrada a continuación.
    </div>
    <div class="col-12 t-c pt10 pb10 fw">
      Contraseña del técnico <br />
      <span class="f30 fw" v-if="password == ''">********</span>
      <span class="f30 fw color-success" v-else>{{password}} <i class="iconfont icon-copy color-primary f22" @click="copyText()"></i></span>
    </div>
    <div class="col-12 t-c">
      <input type="text" class="bg-color-white h4 b-s-2 r5 pl5 pr5 w20 fw uppercase" placeholder="Código de instalación" v-model="install_code">
      <input type="button" value="Confirmar" class="b1 h4 pl5 pr5 r5 f14" @click="make_install_password()" :disabled="install_code.length != 8" :class="[install_code.length == 8?'bg-color-primary color-white':'color-muted']">
    </div>
    <div class="h5"></div>
  </div>
</template>
<script>
export default {
  name: 'InstallCode',
  data () {
    return {
      install_code: '',
      password: ''
    }
  },
  created: function () {
    //获取URL参数
    if(this.$route.query.install_code && this.$route.query.install_code.length == 8){
      this.install_code = this.$route.query.install_code;
      this.make_install_password();
    }
  },
  methods: {
    make_install_password() {
      var post_data = {}
      post_data.install_code = this.install_code
      this.post(this.api_url + 'Tec/make_install_password',post_data,true).then((res)=>{
        if(res.status == 1){
          this.password = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    async copyText() {
      if(!this.password){
        return;
      }
      try {
        await navigator.clipboard.writeText(this.password);
        this.$store.commit('setAlert',{type:'success',msg: "Copiado"});
      } catch (err) {
        this.$store.commit('setAlert',{type:'error',msg: "Error"});
      }
    }
  },
  watch: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Fun/InstallCode.vue